import { useIsFocused, useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';

export default function useSetScreenOptions(
  options: Partial<{
    title: string;
    headerRight: () => JSX.Element;
  }>
) {
  const isFocused = useIsFocused();
  const navigation = useNavigation();

  useEffect(() => {
    if (isFocused) navigation.setOptions(options);
  }, [options, isFocused, navigation]);

  return { isFocused };
}
